import React from "react";
import { Snackbar, Alert, AlertTitle, Box, Slide, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

const FloatingAlert = ({ open, onClose, message, severity = "success" }) => {
  const theme = useTheme();

  const config = {
    success: { accent: theme.palette.success.main, title: "Berhasil" },
    error: { accent: theme.palette.secondary.main, title: "Gagal" },
    warning: { accent: theme.palette.warning.main, title: "Perhatian" },
    info: { accent: theme.palette.info.main, title: "Informasi" },
  };
  const current = config[severity] || config.info;

  const Transition = (props) => <Slide direction="left" {...props} />;

  return (
    <Snackbar
      open={open}
      autoHideDuration={4500}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      TransitionComponent={Transition}
      sx={{
        p: 1.5,
        width: { xs: "auto", sm: 380 },
        maxWidth: "calc(100vw - 24px)",
        "& .MuiAlert-root": {
          alignItems: "flex-start",
          p: 0,
          border: 0,
          display: "block",
          borderRadius: "14px",
          backgroundColor: "transparent",
        },
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="standard"
        icon={false}
        sx={{
          position: "relative",
          overflow: "hidden",
          borderRadius: "14px",
          border: `1px solid ${alpha(theme.palette.common.black, 0.06)}`,
          boxShadow: "0 16px 40px rgba(17, 31, 55, 0.16)",
          backgroundColor: theme.palette.background.paper,
          color: "text.primary",
          "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: 4,
            backgroundColor: current.accent,
          },
          "& .MuiAlert-message": { pl: 2.5, pr: 1, py: 1.5, width: "100%" },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          <Box
            sx={{
              width: 22,
              height: 22,
              flexShrink: 0,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              color: "#fff",
              backgroundColor: current.accent,
              fontSize: 12,
              fontWeight: 800,
            }}
          >
            {severity === "success" ? "✓" : severity === "error" ? "!" : "i"}
          </Box>
          <AlertTitle
            sx={{
              m: 0,
              fontSize: 13.5,
              fontWeight: 800,
              letterSpacing: "-0.01em",
              color: "text.primary",
            }}
          >
            {current.title}
          </AlertTitle>
        </Box>
        <Box
          sx={{
            mt: 0.5,
            ml: "38px",
            fontSize: 13,
            lineHeight: 1.5,
            color: "text.secondary",
            wordBreak: "break-word",
          }}
        >
          {message}
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default FloatingAlert;
